import { defineBrickManifest } from "../../brick-manifest.js";
import { defineProps } from "../props/helpers.js";
import { CgSpaceBetween } from "react-icons/cg";

//#region src/shared/bricks/manifests/spacer.manifest.ts
const manifest = defineBrickManifest({
	type: "spacer",
	name: "Spacer",
	category: "container",
	description: "A flexible element to create space between bricks.",
	staticClasses: "self-stretch",
	minWidth: { desktop: 50 },
	defaultWidth: {
		mobile: "auto",
		desktop: "50px"
	},
	minHeight: { mobile: 30 },
	icon: CgSpaceBetween,
	props: defineProps({})
});
const examples = [
	{
		description: "Transparent spacer of 100px wide",
		type: "spacer",
		props: { width: "100px" }
	},
	{
		description: "Transparent spacer of 20px wide",
		type: "spacer",
		props: { width: "20px" }
	},
	{
		description: "Transparent spacer set in % (percentage)",
		type: "spacer",
		props: { width: "20%" }
	}
];

//#endregion
export { examples, manifest };
//# sourceMappingURL=spacer.manifest.js.map